import React from "react";
import { FormattedMessage } from "react-intl";
import { Text } from "@chakra-ui/react";

const StatementDescriptor = ({ descriptor, ...props }) => {
  if (!descriptor) {
    return null;
  }

  return (
    <Text data-testid="statement-descriptor" fontSize="xs" color="tertiaryText" {...props}>
      <FormattedMessage
        defaultMessage={`Charge will appear on your statement as "{descriptor}"`}
        description="label"
        values={{ descriptor }}
      />
    </Text>
  );
};

export default StatementDescriptor;
